/* Geeká UI — comportamento comum (13/10/2026): aparecer ao rolar (.gk-reveal → .is-in), com atraso em escada dentro de [data-gk-stagger]. */
(function () {
  function iniciar(raiz) {
    var els = [].slice.call((raiz || document).querySelectorAll('.gk-reveal:not(.is-in)'));
    if (!els.length) return;
    (raiz || document).querySelectorAll('[data-gk-stagger]').forEach(function (g) {
      [].slice.call(g.querySelectorAll('.gk-reveal')).forEach(function (el, i) { el.style.setProperty('--gk-d', Math.min(i, 8) * 0.07 + 's'); });
    });
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('is-in'); }); return;
    }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }
  document.addEventListener('DOMContentLoaded', function () { iniciar(); });
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
  window.GeekaUI = { reveal: iniciar };
})();

/* Configuradores por passos (14/10/2026): [data-gk-pasos] > .gk-paso[data-titulo][data-ayuda] → um passo de cada vez, como um jogo:
   bolinhas numeradas (clicáveis), "Paso N de M", título, instruções, Anterior / Siguiente e o total sempre à vista. Sem JS fica tudo aberto. */
(function () {
  function pasos(raiz) {
    (raiz || document).querySelectorAll('[data-gk-pasos]:not(.is-ready)').forEach(function (box) {
      var ps = [].filter.call(box.children, function (c) { return c.classList.contains('gk-paso'); }), n = ps.length, at = 0;
      if (n < 2) return;
      box.classList.add('is-ready');
      var cab = document.createElement('div'); cab.className = 'gk-pasos__cab';
      cab.innerHTML = '<ol class="gk-pasos__dots">' + ps.map(function (p, i) {
        return '<li><button type="button" data-i="' + i + '" aria-label="Paso ' + (i + 1) + ': ' + p.dataset.titulo + '">' + (i + 1) + '</button></li>'; }).join('') +
        '</ol><p class="gk-pasos__n" aria-live="polite"></p><h3 class="gk-pasos__tit"></h3><p class="gk-pasos__ayuda"></p>';
      var pe = document.createElement('div'); pe.className = 'gk-pasos__nav';
      pe.innerHTML = '<button type="button" class="gk-pasos__ant">← Anterior</button><span class="gk-pasos__tot"></span><button type="button" class="button gk-pasos__sig">Siguiente →</button>';
      box.insertBefore(cab, ps[0]); box.appendChild(pe);
      var fila = document.createElement('div'); fila.className = 'gk-pasos__fila'; fila.appendChild(cab.querySelector('.gk-pasos__dots')); box.insertBefore(fila, cab);
      var sec = box.closest('section'), vis = sec && sec.querySelector('.gk-cmp__visual, .gk-pal__visual, .gk-let__visual');
      if (vis && window.ResizeObserver) {                 // a fila fica logo por baixo da vista fixa (telemóvel/tablet)
        var medir = function () { var fixa = getComputedStyle(vis).position === 'sticky' && innerWidth < 990; sec.style.setProperty('--gk-vis-h', (fixa ? vis.offsetHeight : 0) + 'px'); };
        new ResizeObserver(medir).observe(vis); addEventListener('resize', medir); medir();
      }
      var tot = box.querySelector('[data-total]'), te = pe.querySelector('.gk-pasos__tot'), sig = pe.querySelector('.gk-pasos__sig');
      function espelho() { var t = tot && tot.textContent.trim(); te.textContent = t && t !== '—' ? 'Total ' + t : ''; }
      if (tot && window.MutationObserver) new MutationObserver(espelho).observe(tot, { childList: true, characterData: true, subtree: true });
      espelho();
      function ir(i, rolar) {
        at = Math.max(0, Math.min(n - 1, i));
        ps.forEach(function (p, k) { p.hidden = k !== at; });
        fila.querySelectorAll('[data-i]').forEach(function (b, k) { b.classList.toggle('is-on', k === at); b.classList.toggle('is-done', k < at);
          if (k === at) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current'); });
        cab.querySelector('.gk-pasos__n').textContent = 'Paso ' + (at + 1) + ' de ' + n;
        cab.querySelector('.gk-pasos__tit').textContent = ps[at].dataset.titulo;
        cab.querySelector('.gk-pasos__ayuda').textContent = ps[at].dataset.ayuda || '';
        pe.querySelector('.gk-pasos__ant').style.visibility = at ? '' : 'hidden';
        sig.style.display = te.style.display = at === n - 1 ? 'none' : '';   // 16/10: .button tem display próprio e ignorava [hidden]
        sig.textContent = at === n - 2 ? 'Ver resumen →' : 'Siguiente →';
        if (rolar) { var vh = parseFloat(getComputedStyle(fila).top) || 0, alvo = fila.getBoundingClientRect().top; if (alvo < vh || alvo > innerHeight * .6) scrollBy({ top: alvo - vh - 8, behavior: 'smooth' }); }
      }
      fila.addEventListener('click', function (e) { var b = e.target.closest('[data-i]'); if (b) ir(+b.dataset.i, true); });
      pe.querySelector('.gk-pasos__ant').addEventListener('click', function () { ir(at - 1, true); });
      sig.addEventListener('click', function () { ir(at + 1, true); });
      ir(0);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { pasos(); }); else pasos();
  document.addEventListener('shopify:section:load', function (e) { pasos(e.target); });
  window.GeekaUI = window.GeekaUI || {}; window.GeekaUI.pasos = pasos;
  // 16/10 (Gabriel): depois de "Añadir" fica na página para poder juntar mais um; atualiza o ícone do carrinho (Section Rendering API)
  window.GeekaUI.adicionado = function (add, msg, txt) {
    var raiz = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
    add.disabled = false; msg.innerHTML = txt + ' <a href="' + raiz + 'cart">Ver carrito →</a>';
    fetch(raiz + '?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
      var el = document.getElementById('cart-icon-bubble'), h = s && s['cart-icon-bubble'];
      if (el && h) { var d = new DOMParser().parseFromString(h, 'text/html').getElementById('shopify-section-cart-icon-bubble'); if (d) el.innerHTML = d.innerHTML; }
    }).catch(function () {});
  };
})();

/* Estado no URL + "Copiar enlace" (7.1, 15/10/2026). Cada configurador usa um prefixo (n_ número · p_ palabra · l_ letrero),
   só aceita valores que existam nos seus botões e grava com replaceState (não enche o histórico). */
(function () {
  var E = {
    ler: function (pref) {
      var q = new URLSearchParams(location.search), o = {}, n = 0;
      q.forEach(function (v, k) { if (k.indexOf(pref + '_') === 0) { o[k.slice(pref.length + 1)] = v.slice(0, 200);   /* 16/10: 40 cortava o enlace da canção */ n++; } });
      return n ? o : null;
    },
    gravar: function (pref, obj) {
      var q = new URLSearchParams(location.search), ks = [];
      q.forEach(function (v, k) { if (k.indexOf(pref + '_') === 0) ks.push(k); });
      ks.forEach(function (k) { q.delete(k); });
      Object.keys(obj).forEach(function (k) { var v = obj[k]; if (v !== undefined && v !== null && String(v) !== '') q.set(pref + '_' + k, v); });
      var s = q.toString();
      try { history.replaceState(history.state, '', location.pathname + (s ? '?' + s : '') + location.hash); } catch (e) {}
    },
    link: function () {                                 // URL pública: só origem + caminho + parâmetros dos configuradores
      var q = new URLSearchParams(location.search), o = new URLSearchParams();
      q.forEach(function (v, k) { if (/^[npl]_/.test(k)) o.set(k, v); });
      var s = o.toString(); return location.origin + location.pathname + (s ? '?' + s : '');
    },
    aplicar: function (raiz, st, attrG, attrV) {          // clica no botão certo de cada grupo (o próprio configurador atualiza o estado)
      if (!st) return;
      Object.keys(st).forEach(function (k) {
        var g = raiz.querySelector('[' + attrG + '="' + k + '"]'); if (!g) return;
        var b = [].filter.call(g.querySelectorAll('[' + attrV + ']'), function (x) { return x.getAttribute(attrV) === st[k]; })[0];
        if (b && !b.classList.contains('is-on')) b.click();
      });
    }
  };
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-copiar]'); if (!b) return;
    var url = E.link(), t0 = b.dataset.txt || (b.dataset.txt = b.textContent);
    var feito = false;
    function ok() { if (feito) return; feito = true; b.textContent = '✓ Enlace copiado'; b.classList.add('is-ok'); setTimeout(function () { b.textContent = t0; b.classList.remove('is-ok'); }, 2200); }
    if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(url).then(ok, falhou); setTimeout(falhou, 1500); } else falhou();   // promessa pode ficar pendente (permissão)
    function falhou() { if (feito) return; var i = document.createElement('input'); i.value = url; document.body.appendChild(i); i.select(); var c = false; try { c = document.execCommand('copy'); } catch (x) {} i.remove(); if (c) ok(); else { feito = true; prompt('Copia este enlace:', url); } }
  });
  window.GeekaUI = window.GeekaUI || {}; window.GeekaUI.estado = E;
})();

/* Estilo (7.1 item 5, para aprovação): resumo da escolha de cada passo + barra fixa no telemóvel com total e botão principal. */
(function () {
  function valor(p) {
    var on = [].map.call(p.querySelectorAll('[aria-checked="true"]'), function (b) { return (b.getAttribute('data-v') || b.getAttribute('data-val') || b.getAttribute('title') || b.textContent || '').replace(/ \((PLA|PETG|ASA)\)/, '').trim(); }).filter(Boolean);
    var txt = [].map.call(p.querySelectorAll('input[type="text"]'), function (i) { return i.value.trim(); }).filter(Boolean);
    return txt.concat(on).join(' · ');
  }
  function resumo(box) {
    var ps = [].filter.call(box.children, function (c) { return c.classList.contains('gk-paso'); });
    var dots = box.querySelectorAll('.gk-pasos__dots [data-i]'); if (!dots.length) return;
    ps.forEach(function (p, i) {
      var d = dots[i]; if (!d) return; var v = valor(p), s = d.parentElement.querySelector('.gk-pasos__val');
      if (!s) { s = document.createElement('span'); s.className = 'gk-pasos__val'; d.parentElement.appendChild(s); }
      s.textContent = v; s.title = (p.dataset.titulo || '') + (v ? ': ' + v : '');
    });
  }
  function barra(sec) {
    var vis = sec.querySelector('[data-gk3d], [data-stage]'), add = sec.querySelector('[data-add]'), tot = sec.querySelector('[data-total]');
    if (!vis || !add || !tot || sec.querySelector('.gk-barra')) return;
    var b = document.createElement('div'); b.className = 'gk-barra';
    b.innerHTML = '<span class="gk-barra__tot"></span><button type="button" class="button gk-barra__btn"></button>';
    var alvo = vis.parentElement; alvo.insertBefore(b, vis.nextSibling);
    var t = b.querySelector('.gk-barra__tot'), btn = b.querySelector('.gk-barra__btn');
    function sync() { t.textContent = tot.textContent.trim() === '—' ? '' : tot.textContent.trim(); btn.textContent = add.textContent.trim() || 'Añadir al carrito'; btn.disabled = add.disabled; }
    btn.addEventListener('click', function () { add.click(); });
    if (window.MutationObserver) { new MutationObserver(sync).observe(tot, { childList: true, characterData: true, subtree: true }); new MutationObserver(sync).observe(add, { attributes: true, childList: true, subtree: true }); }
    sync();
  }
  function iniciar(raiz) {
    (raiz || document).querySelectorAll('[data-gk-pasos]').forEach(function (box) {
      var sec = box.closest('section') || box.parentElement;
      var r = function () { resumo(box); };
      sec.addEventListener('click', function () { setTimeout(r, 0); }); sec.addEventListener('input', r); setTimeout(r, 300);
      barra(sec);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { iniciar(); }); else iniciar();
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();
